<template>
	<v-layout row mt-3>
		<v-flex xs2/>
		<v-flex xs8>
			<v-textarea
				outline
				browser-autocomplete="off"
				style="padding-right: 20px"
				aria-label="hint"
				:required="false"
				disabled
				auto-grow
				type="text" v-model="hint"></v-textarea>
		</v-flex>
	</v-layout>
</template>

<script>
	export default {
		name: "ActivitiesTableHint",

		props: {
			hint: {
				type: String,
				default: ""
			}
		}
	};
</script>

<style scoped>

</style>